import { makeStyles } from "@material-ui/core/styles";
const normal = 70
const subnormal = 220 

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
  },
  backgrounclients: {
    backgroundSize: "cover",
    backgroundImage: "linear-gradient(rgba(35, 37, 41, 0.6), rgba(35, 37, 41, 0.6)), url('/images/clients/backgroundClients.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    //minHeight: `calc(100vh - ${normal}px)`,
  },
  Containertittle: { 
    height: "100%", 
    display: "grid",
    flexDirection: "column",
    justifyContent: "center", 
    paddingBottom: theme.spacing(18),
    paddingTop: theme.spacing(18),

    [theme.breakpoints.down("sm")]: {
      paddingBottom: theme.spacing(15),
      paddingTop: theme.spacing(15),
    },
    [theme.breakpoints.down("xs")]: {
      paddingBottom: theme.spacing(10),
      paddingTop: theme.spacing(10),
    },
  },
  gridtittle: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(8),
    },
  },
  tittleclients: {
    fontWeight: "bold",
    color: "white",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(4),
      textAlign: "center",
    },
  },
  subtittleclients: { 
    color: "white",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(10),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(6),
      textAlign: "center",
    },
  }, 
  tittleicon: {
    pointerEvents: 'none',
    width: theme.spacing(45),
    height: theme.spacing(35),
  },
  arrowicon: {
    pointerEvents: 'none',
    width: theme.spacing(5),
    height: theme.spacing(5),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(8),
      height: theme.spacing(8),
      marginTop: theme.spacing(10),
    },
  },

   
  backgrounOurclients: {
    backgroundSize: "cover",
    backgroundImage: "linear-gradient(rgba(41, 67, 116, 0.55), rgba(0, 0, 0)), url('/images/clients/BackgroundOurClients.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
  ContainerOurclients: {
    paddingBottom: theme.spacing(7),
    paddingTop: theme.spacing(7),
    [theme.breakpoints.down("sm")]: {
      paddingBottom: theme.spacing(3),
      paddingTop: theme.spacing(3),
    },
  },
  tittleOurclients: {
    fontWeight: "bold",
    color: "white",
    fontFamily: "Century-Gothic",
    paddingTop: theme.spacing(2),
    marginBottom: theme.spacing(10),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(4),
    },
  },
  subtittleOurclients: {
    color: "white",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(4),
    },
  },
  avatarclients: {
    pointerEvents: 'none',
    width: theme.spacing(30),
    height: theme.spacing(20),
  },
  clientcidu: {
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
  },
  text: {
    fontWeight: "bold",
    color: "white",
    fontFamily: "Century-Gothic",
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(3),
    },
  },
  subcontentOurclients: {
    color: "white",
    fontFamily: "Century-Gothic",
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(5),
    },
  },
}));
export default useStyles;
